export const LOAD_ADMIN_POSTS = '[ADMIN_BLOG] LOAD_ADMIN_POSTS'
export const LOAD_ADMIN_POSTS_COUNT = '[ADMIN_BLOG] LOAD_ADMIN_POSTS_COUNT'
export const FIND_POST_BY_SLUG = '[ADMIN_BLOG] FIND_POST_BY_SLUG'
export const PUBLISH_POST = '[ADMIN_BLOG] PUBLISH_POST'

export const LOAD_CATEGORIES = '[ADMIN_BLOG] LOAD_CATEGORIES'
export const CREATE_CATEGORY = '[ADMIN_BLOG] CREATE_CATEGORY'
export const EDIT_CATEGORY = '[ADMIN_BLOG] EDIT_CATEGORY'
export const DELETE_CATEGORY = '[ADMIN_BLOG] DELETE_CATEGORY'
